import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";

export const DATA_GRID_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.SELECTION,
  DATA_GRID_COLUMN_TYPES.CODE,
  DATA_GRID_COLUMN_TYPES.TITLE,
  DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
  DATA_GRID_COLUMN_TYPES.GRADING_TYPE,
  DATA_GRID_COLUMN_TYPES.WEIGHT,
  DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS,
  DATA_GRID_COLUMN_TYPES.TAGS,
  DATA_GRID_COLUMN_TYPES.DESCRIPTION,
  DATA_GRID_COLUMN_TYPES.ID,
  DATA_GRID_COLUMN_TYPES.LIST_PARENT,
  DATA_GRID_COLUMN_TYPES.ARCHIVE,
];
export const DEFAULT_HIDDEN_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.DESCRIPTION,
  DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  DATA_GRID_COLUMN_TYPES.GRADING_TYPE,
  DATA_GRID_COLUMN_TYPES.WEIGHT,
  DATA_GRID_COLUMN_TYPES.ID,
  DATA_GRID_COLUMN_TYPES.LIST_PARENT,
  DATA_GRID_COLUMN_TYPES.ARCHIVE,
];

export const NON_CONFIGURABLE_COLUMNS = {
  start: [
    DATA_GRID_COLUMN_TYPES.SELECTION,
    DATA_GRID_COLUMN_TYPES.CODE,
    DATA_GRID_COLUMN_TYPES.TITLE,
  ],
};

export const STANDARDS_DATA_GRID_PROPERTIES = {
  [DATA_GRID_COLUMN_TYPES.POWER_STANDARD]: {
    customConfig: {
      property: "dataSetNodeWrapper.properties.isPowerStandard",
    },
  },
  [DATA_GRID_COLUMN_TYPES.WEIGHT]: {
    customConfig: {
      property: "dataSetNodeWrapper.properties.weight",
    },
  },
  [DATA_GRID_COLUMN_TYPES.GRADE_LEVELS]: {
    customConfig: {
      property: "dataSetNodeWrapper.properties.grades",
    },
  },
  [DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS]: {
    customConfig: {
      property: "dataSetNodeWrapper.properties.subjects",
    },
  },
  [DATA_GRID_COLUMN_TYPES.TAGS]: {
    customConfig: {
      property: "dataSetNodeWrapper.properties.tags",
    },
  },
  [DATA_GRID_COLUMN_TYPES.ARCHIVE]: {
    customConfig: {
      property: "dataSetNodeWrapper.properties.isArchived",
    },
  },
};
